import React, { useState, useEffect } from 'react';
import { useEditor } from '../../context/EditorContext'; // Opcional, se quiseres editar textos
// Se não usares o EditorContext aqui, podes remover a importação e usar texto fixo.

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Verifica se já aceitou cookies
        const consent = localStorage.getItem('vintage_cookie_consent');
        if (!consent) {
            // Pequeno delay para animação suave de entrada
            const timer = setTimeout(() => setIsVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('vintage_cookie_consent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 w-full bg-gray-900 text-white z-[9999] shadow-[0_-4px_20px_rgba(0,0,0,0.3)] border-t border-gray-800 animate-slide-up">
            <div className="container mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-6">
                
                {/* Texto */}
                <div className="flex-1 text-center md:text-left">
                    <h4 className="text-amber-500 font-serif font-bold text-lg mb-2 tracking-wide">
                        Utilizamos Cookies
                    </h4>
                    <p className="text-gray-400 text-sm font-light leading-relaxed max-w-2xl">
                        Este site utiliza cookies para garantir que tem a melhor experiência de navegação. 
                        Ao continuar a utilizar este site, concorda com a nossa utilização de cookies.
                    </p>
                </div>

                {/* Botões */}
                <div className="flex items-center gap-4 flex-shrink-0">
                    <a 
                        href="/cookie_policy" // Ou usa um botão que chama setCurrentPage('cookie_policy') se tiveres acesso
                        className="text-gray-400 hover:text-white text-xs uppercase tracking-widest transition-colors font-bold border-b border-transparent hover:border-white pb-1"
                    >
                        Saber Mais
                    </a>
                    
                    <button 
                        onClick={handleAccept}
                        className="bg-amber-600 hover:bg-amber-700 text-white text-xs font-bold uppercase tracking-widest px-8 py-3 rounded-sm transition-all shadow-lg hover:shadow-amber-900/20"
                    >
                        Aceitar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;